<h1 class="page-title">Dashboard Overview</h1>

<div class="stats-grid">
  <div class="stat-card" *ngFor="let stat of statCards">
    <div class="stat-icon" [class]="stat.color">
      <i [class]="stat.icon"></i>
    </div>
    <h3>{{ stat.value }}</h3>
    <p>{{ stat.label }}</p>
  </div>
</div>

<div class="row">
  <div class="col-12 col-lg-8 mb-4">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Recent Activity</h5>
      </div>
      <div class="card-body">
        <p>
          This is where you can add charts, tables, or other content for your
          admin dashboard.
        </p>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-4 mb-4">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Quick Actions</h5>
      </div>
      <div class="card-body">
        <div class="d-grid gap-2">
          <button class="btn btn-primary" (click)="addNewUser()">
            Add new user
          </button>
          <button class="btn btn-outline-primary" (click)="addNewReservation()">
            Add new reservation
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
